export default __webpack_public_path__ + "static/media/Tech Circle.61543cd2.svg";